import { gql } from 'apollo-angular';

const GET_PRODUCTS_STATISTICS_BY_RFP = gql`
  query GetProductsByRfp($rfpId: Long) {
    optimizedRfp(id: $rfpId) {
      recipients {
        seller {
          id
          name
        }
        responseSubmissionDate
        responseAmendmentDate
      }
      products {
        id
        baseProductId
        catalogNumber
        description
        packageString
        status
        brandName
        manufacturer {
          id
          name
        }
        parentManufacturer {
          id
          name
        }
        distributor {
          id
          name
        }
        parentDistributor {
          id
          name
        }
        aptitudeCategory {
          id
          name
        }
        categories {
          id
          name
          parents {
            id
            name
          }
        }
        productSource
        scopeStatus
        seller {
          id
          name
        }
        sysSeller {
          id
          name
        }
        spend {
          actualSpend
        }
        statistics {
          crossReferenceStatistic {
            crossCount
          }
        }
        manufacturerCatalogNumber
      }
    }
  }
`;

export default GET_PRODUCTS_STATISTICS_BY_RFP;
